import React from 'react';
import ReactDOM from 'react-dom';
import RouteConfig from './RouteConfig';
import { store } from './store/store';
import { Provider } from 'react-redux';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import "./global.css";
import "./movil.css";

ReactDOM.render(
  <React.StrictMode>
    <RouteConfig />
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorkerRegistration.register();



